import styled from 'styled-components';

export const StyledGroups = styled.div`
    padding: 2rem;
`;
